import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { staffStatusColor } from '../variables/index'
import { Badge } from 'antd'

class StaffStatus extends Component {
  render() {
    const { value, _key } = this.props
    return (
      <span {...this.props}>
        <Badge
          dot
          style={{
            background: staffStatusColor[_key],
          }}
        />
        <a style={{ marginLeft: '10px' }}>{value}</a>
      </span>
    )
  }
}

StaffStatus.propTypes = {
  value: PropTypes.string.isRequired,
  _key: PropTypes.string.isRequired,
}
StaffStatus.defaultProps = { value: '', _key: '' }

export default StaffStatus
